import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import ProjectsTable from "./ProjectsTable";
import ProjectCreateModal from "./ProjectCreateModal"
import {checkPermission, CAN_CREATE_PROJECTS} from "../../../lib/permissions";

export default class Projects extends Component {

    state = {
        createProjectModalOpen: false,
    }

    render() {

        const {createProjectModalOpen} = this.state

        return (
            <div className="d-flex flex-column">
                <div className="d-flex flex-row align-items-center justify-content-end p-3">
                    {checkPermission(CAN_CREATE_PROJECTS) && <Button
                        size="sm"
                        color="success"
                        onClick={() => this.setState({createProjectModalOpen: true})}
                    >
                        <FontAwesomeIcon
                            color="#fff"
                            icon="plus"/>{' '}
                        Add Project
                    </Button>}
                </div>
                <ProjectsTable/>
                <ProjectCreateModal
                    isOpen={createProjectModalOpen}
                    toggle={() => this.setState({createProjectModalOpen: !createProjectModalOpen})}/>
            </div>
        )

    }

}